import { isProduction, DOMAIN } from '../libs/constants'
import { withQuerystring } from '../libs/utils'

const TIMESTAMP = 'timestamp'

const servicePrefix = isProduction ? '' : 'dev-'

export const userEndpoint = `${DOMAIN}/${servicePrefix}wallet-member`

export const loginRoute = '/sessions'
export const vendorLoginRoute = '/vendor/sessions'

export const guestEndpoint = `${DOMAIN}/${servicePrefix}aifian-guests`

export const sendSMSRoute = '/auth-code'
export const confirmSMSRoute = '/auth-code/confirmation'

export const slashEndpoint = `${DOMAIN}/${servicePrefix}products-slash`

export const terminateCreamItemRoute = itemId => `/${itemId}`
export const getSlashInfoRoute = '/info'

// * new routes:
export const sellerHistoriesRoute = timestampTz =>
  withQuerystring('/sellers/histories', TIMESTAMP, timestampTz) // 取得開團紀錄
export const sellerHistoryDetailRoute = (itemId, timestampTz) =>
  withQuerystring(`/sellers/histories/${itemId}`, TIMESTAMP, timestampTz) // 取得開團明細
export const instalmentHistoriesRoute = periodId =>
  `/sellers/histories/instalments/${periodId}` // 取得分期紀錄
export const inflowHistoriesRoute = timestampTz =>
  withQuerystring('/histories/inflows', TIMESTAMP, timestampTz) // 取得收款紀錄
export const outflowHistoriesRoute = timestampTz =>
  withQuerystring('/histories/outflows', TIMESTAMP, timestampTz) // 取得付款 / 提領紀錄
export const inflowHistoryDetailRoute = transactionId =>
  `/histories/sellers/${transactionId}` // 取得收款紀錄詳細資訊
export const outflowPaymentDetailRoute = transactionId =>
  `/histories/buyers/${transactionId}` // 取得付款紀錄詳細資訊
export const outflowWithdrawDetailRoute = withdrawId =>
  `/histories/withdraws/${withdrawId}` // 取得提領紀錄詳細資訊
export const withdrawInfoRoute = amount => `/withdraws?amount=${amount}` // 取得實際提領金額相關資訊
export const createWithdrawRoute = '/withdraws' // 申請提領
export const itemEntryInfoRoute = itemId => `/buyers/payments/${itemId}` // 取得購買連結資訊
export const buyerInstalmentsInfoRoute = periodId =>
  `/buyers/instalments/${periodId}` // 取得逾期款項付款資訊

export const purchaseCreamItemWithTokenRoute = '/purchase'
export const getHistoryListRoute = timestampTz =>
  `/items${timestampTz ? `?timestamp=${timestampTz}` : ''}`
export const getTransactionsRoute = (itemId, timestampTz) =>
  `/items/${itemId}/transactions${
    timestampTz ? `?timestamp=${timestampTz}` : ''
  }`
export const getItemInfoMemberRoute = itemId => `/payment/${itemId}/member`
export const getItemInfoPublicRoute = itemId => `/payment/${itemId}`
export const sendPurchasedBackupEmailRoute = '/payment/backup'
export const sendPurchasedEmailToSellerRoute = '/payment/result'

export const paymentEndpoint = `${DOMAIN}/${servicePrefix}payment`

export const createTapPayOrderRoute = '/tappay/slash/direct-pay'
export const tapPayConfigGuestRoute = '/tappay/config'
export const tapPayConfigMemberRoute = ({ itemId, orderNo }) =>
  `/tappay/config?${itemId ? `cream_item_id=${itemId}` : `order_no=${orderNo}`}`

// * new routes:
export const createTapPayInstalmentRoute = '/tappay/slash/instalment/direct-pay' // 逾期款項付款
export const paymentInfoGuestRoute = itemId =>
  `/slash/buyers/guests/payments/${itemId}` // 取得非會員付款頁面資訊
export const paymentInfoMemberRoute = itemId =>
  `/slash/buyers/members/payments/${itemId}` // 取得會員付款頁面資訊

export const buyerPeriodicInfoRoute = orderNo =>
  `/buyers/payments/periodic?order_no=${orderNo}` // 取得定期定額重新付款頁面資訊
export const createTapPayPeriodicRoute = '/tappay/slash/periods/direct-pay' //逾期定期定額付款
export const getPurchaseResult = (recTradeId, orderNo) =>
  `/slash/transaction-result/?rec_trade_id=${recTradeId}&order_no=${orderNo}`
